/// <amd-module name="VSS/Features/Charts/Internal/CompatUtilities" />

// Encapsulates repeat occurrences of behaviors previously handled by framework.

export function isHighContrastMode(): boolean {
    let isAutoHighContrast = false;
    const probe = document.createElement("span");
    probe.style.color = "#123456";
    document.body.appendChild(probe);
    const style = getComputedStyle(probe);

    if (style && style.color.replace(/ /g, "") !== "rgb(18,52,86)" && /^rgb\(\d+,\s?\d+,\s?\d+\)$/.test(style.color)) {
        isAutoHighContrast = true;
    }

    probe.parentNode.removeChild(probe);
    return isAutoHighContrast;
}

export function isNumeric(n: any) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function shiftToUTC(date: Date): Date {
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    );
}

export function getShortMonth(date: Date): string {
    return date.toLocaleDateString(navigator.language, { month: "short" });
}
